module.exports = __webpack_public_path__ + "img/agency.6a67a613.svg";